import React from 'react';

const HideByPlatformFormElement = ({register,item,itemName}) => {
    return (
        <div>
             <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                {...register(item)}
              />
              <label className="form-check-label">{itemName}</label>
            </div>
        </div>
    );
}

export default HideByPlatformFormElement;
